export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_02.341ba97b.jpg";